import { render, staticRenderFns } from "./AgentMemberUpdateComponent.vue?vue&type=template&id=3bed24f4&"
import script from "./AgentMemberUpdateComponent.vue?vue&type=script&lang=js&"
export * from "./AgentMemberUpdateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports